<template>
  <div class="que-container">
    <div class="tabbar-container">
      <div class="popup-back" @click="FatherBack">
        <van-icon name="arrow-left" />
        返回
      </div>
      模拟练习
    </div>

    <div class="middle-container">
      <div class="que-tips">
        <div class="que-type">{{ que[queCount].type }}题</div>
        <div class="que-count" style="color: #1dc5aa">得分：{{ fraction }}</div>
        <div class="que-count">
          <span style="color: #3282ef; font-size: 1.1rem">{{ `${queCount + 1} ` }}</span>
          <span style="color: #333333; font-size: 0.95rem">/{{ que.length }}</span>
        </div>
      </div>
      <div class="line" />
      <div class="que-message">
        <div class="que-title">{{ que[queCount].title }}</div>

        <div v-for="(item, index) in que[queCount].options" @click="chooseXx(index)" v-show="!que[queCount].states" :key="index" class="que-xx" :class="item.choose ? 'que-xx-choose' : ''">
          {{ item.ans }}{{ que[queCount].type === "判断" ? "" : ".&nbsp;&nbsp;" + item.text }}
          <van-icon :name="item.choose ? 'circle' : ''" />
        </div>

        <div v-for="(item, index) in que[queCount].options" v-show="que[queCount].states" :key="index + 10" class="que-xx" :class="item.choose && que[queCount].answer.indexOf(item.ans) != -1 ? 'que-xx-choose-success' : item.choose ? 'que-xx-choose-dfed' : ''">
          {{ item.ans }}{{ que[queCount].type === "判断" ? "" : ".&nbsp;&nbsp;" + item.text }}
          <van-icon :color="que[queCount].answer.indexOf(item.ans) != -1 ? '#11D150' : item.choose ? '#FF0000' : ''" :name="que[queCount].answer.indexOf(item.ans) != -1 ? 'success' : item.choose ? 'cross' : ''" />
        </div>

        <div v-show="que[queCount].states" :style="que[this.queCount].answer === que[this.queCount].userAnswer ? 'color: #11D150' : 'color: #FF0000'" style="text-align: center; font-weight: 500; margin-top: 1rem">
          {{ que[this.queCount].answer === que[this.queCount].userAnswer ? "回答正确" : "回答错误" }}
        </div>
        <div v-show="que[queCount].states" style="text-align: center; font-weight: 500; margin-top: 0.5rem">
          正确答案:
          <span style="color: #11d150">{{ que[this.queCount].answer }}</span>
        </div>
      </div>

      <div class="que-go">
        <van-button class="que-gobutton" round :disabled="backDis" @click="back" color="linear-gradient(to right, #1CCAA3, #2D8FFC)"> 上一题 </van-button>
        <van-button class="que-gobutton" round :disabled="nextDis" @click="next" color="linear-gradient(to right, #1CCAA3, #2D8FFC)">
          {{ nextText }}
        </van-button>
      </div>
    </div>

    <div class="bottom-container">
      <div style="flex: 1; display: flex; flex-direction: row">
        <van-icon name="success" color="#1DD358" />
        <div style="color: #1dd358; margin-right: 1rem; margin-left: 0.5rem">
          {{ correct }}
        </div>
        <van-icon name="cross" color="#FF0000" />
        <div style="color: #ff0000; margin-right: 1rem; margin-left: 0.5rem">
          {{ wrong }}
        </div>
      </div>
      <div @click="finish" class="bottom-jj">交卷</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "que",
  components: {},
  computed: {},
  props: {
    queForm: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      IdCard: localStorage.getItem("IdCard"),
      // 下一题按钮文字。
      nextText: "确定",

      // 下一题禁用。
      nextDis: false,
      // 上一题禁用。
      backDis: true,

      // 单选分数。
      DanScoreqq: 1,
      // 多选分数。
      DuoScoreqq: 1,
      // 判断分数。
      PanScoreqq: 1,
      // 及格分数。
      CutOffScoresqq: 60,

      // 正确题目数量。
      correct: 0,
      // 错误题目数量。
      wrong: 0,
      // 当前题目数。
      queCount: 0,
      // 当前分数。
      fraction: 0,
      // 是否及格
      TESTSTATUS: "是否及格",

      // 题目主题集合。
      que: [{ type: "...", title: "..." }],
      // 错题集合
      ctList: [],
    };
  },
  watch: {},
  created() {},
  async mounted() {
    this.DanScoreqq = this.queForm.DanScoreqq;
    this.DuoScoreqq = this.queForm.DuoScoreqq;
    this.PanScoreqq = this.queForm.PanScoreqq;
    this.CutOffScoresqq = this.queForm.CutOffScoresqq;

    await this.$store
      .dispatch("api/getSimulatePaper", this.queForm)
      .then((response) => {
        if (response.success) {
          this.que = response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  destroyed() {},
  methods: {
    FatherBack() {
      Dialog.confirm({
        title: "是否退出答题",
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then(() => {
          this.$emit("fatherMethod");
        })
        .catch(() => {});
    },
    finish() {
      this.TESTSTATUS = Number(this.CutOffScoresqq) <= Number(this.fraction) ? "及格" : "不及格";
      Dialog.confirm({
        title: "是否交卷",
        message: `得分：${this.fraction}\n回答正确：${this.correct}题 - 回答错误：${this.wrong}题`,
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then(() => {
          this.save();
        })
        .catch(() => {});
    },
    async save() {
      if (this.ctList.length > 0) {
        let cuotiForm = new URLSearchParams();
        this.ctList.forEach((ct, index) => {
          cuotiForm.append(`cuotiZu[${index}][TID]`, ct.TID);
          cuotiForm.append(`cuotiZu[${index}][ShiTi]`, ct.ShiTi);
          cuotiForm.append(`cuotiZu[${index}][Xuanxiang]`, ct.Xuanxiang);
          cuotiForm.append(`cuotiZu[${index}][UserAnswers]`, ct.UserAnswers);
          cuotiForm.append(`cuotiZu[${index}][PaperAnswers]`, ct.PaperAnswers);
          cuotiForm.append(`cuotiZu[${index}][IdCard]`, ct.IdCard);
          cuotiForm.append(`cuotiZu[${index}][ttype]`, ct.ttype);
        });
        const cuoti = await this.$store.dispatch("api/SaveCuoTi", cuotiForm);

        if (!cuoti.success) {
          this.$toast("提交错题失败");
        }
      }

      let jjForm = new URLSearchParams();
      jjForm.append("IdCard", this.IdCard);
      jjForm.append("SCORE", this.fraction);
      jjForm.append("TESTSTATUS", this.TESTSTATUS);
      // jjForm.append("SubjectID", this.queForm.QuesID);
      jjForm.append("SubjectID", this.queForm.SubjectID);
      console.log(111, this.queForm);
      jjForm.append("ClassID", this.queForm.ClassID);
      jjForm.append("ClassName", this.queForm.ClassName);
      const jiaojuan = await this.$store.dispatch("api/OnlyTestUserSubmitSocre", jjForm);
      if (jiaojuan.success) {
        this.$toast("提交成功");
        this.$emit("fatherMethod");
      } else {
        this.$toast("交卷失败请重试");
      }
    },
    back() {
      this.queCount = this.queCount - 1;
      this.nextDis = false;

      if (this.que[this.queCount].states) {
        this.nextText = "下一题";
      }

      if (this.queCount === 0) {
        this.backDis = true;
        return;
      }
    },
    next() {
      var t = true;
      this.que[this.queCount].options.forEach((q) => {
        if (q.choose) {
          t = false;
        }
      });
      if (t) {
        this.$toast("请选择答案");
        return;
      }

      if (!this.que[this.queCount].states && this.nextText === "确定") {
        // 确定答案 切换样式。
        this.que[this.queCount].options.forEach((q) => {
          if (q.choose) {
            if (!this.que[this.queCount].userAnswer) {
              this.que[this.queCount].userAnswer = "";
            }
            this.que[this.queCount].userAnswer = this.que[this.queCount].userAnswer + q.ans;
          }
        });

        if (this.que[this.queCount].answer === this.que[this.queCount].userAnswer) {
          this.correct = this.correct + 1;
          switch (this.que[this.queCount].type) {
            case "单选":
              this.fraction = this.fraction + this.DanScoreqq;
              break;
            case "多选":
              this.fraction = this.fraction + this.DuoScoreqq;
              break;
            case "判断":
              this.fraction = this.fraction + this.PanScoreqq;
              break;
          }
        } else {
          // 保存错题
          this.ctList.push({
            TID: this.que[this.queCount].seq,
            IdCard: this.IdCard,
            ShiTi: this.que[this.queCount].title,
            // Xuanxiang: JSON.stringify(this.que[this.queCount].options),
            Xuanxiang: "",
            UserAnswers: this.que[this.queCount].userAnswer,
            PaperAnswers: this.que[this.queCount].answer,
            ttype: this.que[this.queCount].type,
          });
          this.wrong = this.wrong + 1;
        }

        this.que[this.queCount].states = true;
        this.nextText = "下一题";
      } else if (this.nextText === "下一题") {
        // 题目加一， 解放上一题按钮。
        this.queCount = this.queCount + 1;
        this.backDis = false;

        // 没答题记录，变为确定按钮。
        if (!this.que[this.queCount].states) {
          this.nextText = "确定";
          return;
        }
      }

      if (this.queCount + 1 === this.que.length) {
        this.nextDis = true;
        return;
      }
    },
    chooseXx(index) {
      if (this.que[this.queCount].states) {
        return;
      }

      if (this.que[this.queCount].type === "多选") {
        this.que[this.queCount].options[index].choose = !this.que[this.queCount].options[index].choose;
      } else {
        // 单选重复选择后不进行操作
        if (this.que[this.queCount].options[index].choose) return;

        // 单选切换选择
        this.que[this.queCount].options.forEach((que, queIndex) => {
          if (index === queIndex) {
            que.choose = true;
          } else {
            que.choose = false;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.que-container {
  width: 100%;
  height: 100%;
  background-color: #f1f1f1;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.tabbar-container {
  width: 100%;
  height: 3rem;
  text-align: center;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #2d8efc;
  position: relative;
  font-size: 1.1rem;

  .popup-back {
    position: absolute;
    left: 20px;
  }
}

.middle-container {
  width: 92%;
  height: 0;
  flex: 1;
  margin: 1.2rem 0;
  background: white;
  border-radius: 10px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  font-weight: normal;
  padding: 0.7rem;
  box-sizing: border-box;

  .que-tips {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .que-count {
      color: #666666;
      font-size: 0.9rem;
    }
    .que-type {
      color: white;
      width: 71px;
      padding-right: 5px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      font-size: 0.8rem;
      background-image: url(../../assets/icon/type.png);
      background-size: 100% 100%;
      border-radius: 5px;
    }
  }

  .line {
    width: 100%;
    height: 1px;
    margin-top: 0.7rem;
    background-color: #f0f0f0;
  }
  .que-message {
    width: 100%;
    flex: 1;
    height: 0;
    margin: 0.5rem 0;
    overflow-y: auto;

    .que-title {
      text-align: left;
      color: #333333;
      font-size: 1rem;
      padding-bottom: 0.5rem;
    }

    .que-xx {
      width: calc(100% - 2px);
      min-height: 2rem;
      background: #fbfbfb;
      border: #e5e5e5 solid 1px;
      border-radius: 5px;
      margin-top: 0.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem 1rem;
      color: #333333;
      font-weight: bold;
      box-sizing: border-box;
    }

    .que-xx-choose {
      color: #00afe8;
      border: #00afe8 solid 1px;
    }

    .que-xx-choose-success {
      color: #11d150;
      border: #00afe8 solid 1px;
    }

    .que-xx-choose-dfed {
      color: #ff0000;
      border: #00afe8 solid 1px;
    }
  }

  .que-go {
    width: 100%;
    height: 35px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .que-gobutton {
      width: 45%;
      height: 100%;
    }
  }
}

.bottom-container {
  width: 100%;
  height: 50px;
  background: white;
  display: flex;
  padding: 0 1.5rem;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;

  .bottom-jj {
    color: white;
    font-size: 0.9rem;
    padding: 0.2rem 1rem;
    border-radius: 999px;
    background-color: #2d8efc;
  }
}
</style>
